export default __webpack_public_path__ + "static/media/programs-button@3x.902b9cc4.png";